export const ERROR_MESSAGE = {
  required: () => `This field is required`,
  minlength: par => `Min ${par.requiredLength} chars is required`,
  email: () => `Invalid email format`
};
